import { useEffect } from 'react';

/**
 * Ajusta `<title>` y la meta description de la página actual y las restaura al
 * desmontar.
 *
 * El sitio es una SPA servida desde CloudFront: el `index.html` que reciben
 * todas las rutas trae el título del home, así que sin esto una URL legal
 * compartida (o abierta por un revisor de Google Play) se anunciaría con el
 * título equivocado.
 */
export function useDocumentMeta(title: string, description?: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute('content') ?? null;
    if (description && meta) meta.setAttribute('content', description);

    return () => {
      document.title = previousTitle;
      if (meta && previousDescription !== null) meta.setAttribute('content', previousDescription);
    };
  }, [title, description]);
}
